<script setup>
import { useEventTracking } from '~/utils/use-event-tracking';

function handleClick() {
  useEventTracking('click', 'Click on about card');
}
</script>

<template>
  <div class="about-card">
    <NuxtLink
      :to="{ name: 'about' }"
      class="about-card__link"
      @click="handleClick"
    >
      <span class="about-card__subtitle">
        Узнайте подробнее о том, <br />
        чем мы занимаемся
      </span>

      <img
        alt="about card title"
        class="about-card__title"
        src="~/assets/images/about-title.svg"
      />
    </NuxtLink>
    <div class="about-card__illustration" />
  </div>
</template>

<style scoped>
.about-card {
  position: relative;

  &__link {
    display: flex;
    flex-direction: column;
    height: 280px;
    width: 100%;
    padding: 24px;
    border-radius: 24px;
    color: #fff6fb;
    background: linear-gradient(-90deg, #6c2179 0%, #b473c0 100%);
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  &__subtitle {
    font-size: 22px;
    font-weight: 500;
    line-height: 32px;
  }

  &__title {
    position: absolute;
    bottom: -2px;
  }

  &__illustration {
    position: absolute;
    top: -55px;
    right: 20px;
    height: 97px;
    width: 95px;
    background-image: url('/images/dudes.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  @media (min-resolution: 192dpi) {
    &__illustration {
      background-image: url('/images/dudes@2x.png');
    }
  }

  @media (--small-vp) {
    &__link {
      height: 153px;
      padding: 24px 16px;
      border-radius: 16px;
    }

    &__subtitle {
      font-size: 16px;
      line-height: 22px;
    }

    &__title {
      width: 261px;
      height: 61px;
    }
  }
}
</style>
